import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetAllCommunityGroupMembers, GetAllCommunityGroupMembersResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<GetAllCommunityGroupMembersResponse, GetAllCommunityGroupMembersResponse>) => response?.data
const getError = (response?: SWRResponse<GetAllCommunityGroupMembersResponse, GetAllCommunityGroupMembersResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetAllCommunityGroupMembersResponse, GetAllCommunityGroupMembersResponse>) => ({});

const useGetAllCommunityGroupMembers = (query?: Partial<GetAllCommunityGroupMembers>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetAllCommunityGroupMembers(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetAllCommunityGroupMembers;